// hooks/useAtualizarDados.ts
import { useState } from "react";
// --------------------- Import Services ---------------------
import { cadastrarReserva } from "../../../services/cadastrarReserva";
import { Reserva } from "../interfaces/Reserva";

export const useCadastrarReserva = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const resetError = () => setError(null); // Função para resetar o erro

  const cadastrar = async (data: Reserva) => {
    setIsLoading(true);
    setError(null);
    setIsSuccess(false);

    try {
      const cadastrar = await cadastrarReserva(data);

      if (cadastrar) {
        setSuccess("Cadastro de Reserva realizado com sucesso!");
      } else {
        setError("Não foi possível realizar o cadastro. Tente Novamente!");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return { cadastrar, isLoading, isSuccess, error, success, resetError };
};
